import Banner from './StoreBannerModule';
import Video from './StoreVideoModule';
import Image from './StoreImageModule';
import List from './StoreListModule';
import Text from './StoreTextModule';
import Filter from './StoreFilterModule';

export default {
  Banner,
  Video,
  Image,
  List,
  Text,
  Filter,
};



// WEBPACK FOOTER //
// ./src/js/components/Store/Modules/index.js